<template>
    <div class="admin-wrapper">
        <el-container class="admin-full-height">
            <!-- Enhanced Sidebar -->
            <el-aside :width="isCollapse ? '64px' : '240px'" class="admin-sidebar transition-all">
                <div class="sidebar-logo">
                    <img v-if="!isCollapse" src="@/assets/logo.png" class="logo-img" />
                    <span v-if="!isCollapse" class="logo-text">后台管理</span>
                    <el-icon v-else class="logo-icon">
                        <Platform />
                    </el-icon>
                </div>

                <el-menu :default-active="activeMenu" class="admin-menu" :collapse="isCollapse"
                    @select="handleMenuSelect" background-color="transparent" text-color="rgba(255,255,255,0.7)"
                    active-text-color="#fff">
                    <el-menu-item index="/admin/dashboard">
                        <el-icon>
                            <DataLine />
                        </el-icon>
                        <template #title>仪表盘</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/users">
                        <el-icon>
                            <User />
                        </el-icon>
                        <template #title>用户管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/forum-manager">
                        <el-icon>
                            <ChatDotSquare />
                        </el-icon>
                        <template #title>论坛管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/chat-manager">
                        <el-icon>
                            <ChatDotSquare />
                        </el-icon>
                        <template #title>聊天管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/textbook">
                        <el-icon>
                            <Reading />
                        </el-icon>
                        <template #title>教材管理</template>
                    </el-menu-item>

                    <el-sub-menu index="questions">
                        <template #title>
                            <el-icon>
                                <Document />
                            </el-icon>
                            <span>题目中心</span>
                        </template>
                        <el-menu-item index="/admin/questions">题目管理</el-menu-item>
                        <el-menu-item index="/admin/question-entry">手工录题</el-menu-item>
                        <el-menu-item index="/admin/import-questions">智能导题</el-menu-item>
                    </el-sub-menu>

                    <el-sub-menu index="papers">
                        <template #title>
                            <el-icon>
                                <Collection />
                            </el-icon>
                            <span>试卷中心</span>
                        </template>
                        <el-menu-item index="/admin/paper-list">试卷管理</el-menu-item>
                        <el-menu-item index="/admin/paper-import">试卷解析</el-menu-item>
                        <el-menu-item index="/admin/paper-upload">原始上传</el-menu-item>
                    </el-sub-menu>

                    <el-menu-item index="/admin/albums">
                        <el-icon>
                            <FolderOpened />
                        </el-icon>
                        <template #title>专辑管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/oss-manager">
                        <el-icon>
                            <Box />
                        </el-icon>
                        <template #title>OSS管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/ad-manager">
                        <el-icon>
                            <Promotion />
                        </el-icon>
                        <template #title>广告管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/announcements">
                        <el-icon>
                            <Bell />
                        </el-icon>
                        <template #title>公告管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/activities">
                        <el-icon>
                            <Collection />
                        </el-icon>
                        <template #title>活动管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/feedbacks">
                        <el-icon>
                            <ChatDotRound />
                        </el-icon>
                        <template #title>反馈管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/pricing">
                        <el-icon>
                            <Money />
                        </el-icon>
                        <template #title>价格管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/download-logs">
                        <el-icon>
                            <Download />
                        </el-icon>
                        <template #title>下载列表</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/pay-test">
                        <el-icon>
                            <Money />
                        </el-icon>
                        <template #title>支付测试</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/ip-blacklist">
                        <el-icon>
                            <CircleClose />
                        </el-icon>
                        <template #title>黑名单管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/sensitive-words">
                        <el-icon>
                            <Warning />
                        </el-icon>
                        <template #title>敏感词管理</template>
                    </el-menu-item>

                    <el-menu-item index="/admin/moderation-logs">
                        <el-icon>
                            <DocumentChecked />
                        </el-icon>
                        <template #title>审核日志</template>
                    </el-menu-item>
                </el-menu>
            </el-aside>

            <el-container class="is-vertical">
                <!-- Integrated Top Header -->
                <el-header class="admin-header">
                    <div class="header-left">
                        <el-icon class="collapse-btn" @click="isCollapse = !isCollapse">
                            <component :is="isCollapse ? 'Expand' : 'Fold'" />
                        </el-icon>
                        <el-breadcrumb class="breadcrumb">
                            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item>管理后台</el-breadcrumb-item>
                            <el-breadcrumb-item>{{ currentRouteTitle }}</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>

                    <div class="header-right">
                        <el-dropdown trigger="click">
                            <div class="admin-user">
                                <el-avatar :size="32" :src="userInfo.avatar || defaultAvatar" />
                                <span class="admin-username">{{ userInfo.username }}</span>
                                <el-icon>
                                    <ArrowDown />
                                </el-icon>
                            </div>
                            <template #list>
                                <el-dropdown-menu>
                                    <el-dropdown-item @click="$router.push('/profile')">个人中心</el-dropdown-item>
                                    <el-dropdown-item @click="$router.push('/home')">返回首页</el-dropdown-item>
                                    <el-dropdown-item divided @click="handleLogout">退出登录</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                </el-header>

                <!-- Main Content Area -->
                <el-main class="admin-main">
                    <router-view v-slot="{ Component }">
                        <transition name="fade-transform" mode="out-in">
                            <component :is="Component" />
                        </transition>
                    </router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import {
    User, Reading, Document, EditPen, Upload, Collection,
    FolderOpened, UploadFilled, Expand, Fold, Platform,
    ArrowDown, Box, Promotion, Bell, DataLine, ChatDotRound, ChatDotSquare, Money, CircleClose,
    Warning, DocumentChecked, Download
} from '@element-plus/icons-vue'

const router = useRouter()
const route = useRoute()
const store = useStore()

const isCollapse = ref(false)
const activeMenu = computed(() => route.path)
const userInfo = computed(() => store.state.user || {})
const defaultAvatar = "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"

const currentRouteTitle = computed(() => {
    const map = {
        '/admin/dashboard': '仪表盘',
        '/admin/users': '用户管理',
        '/admin/questions': '题目管理',
        '/admin/question-entry': '手工录题',
        '/admin/import-questions': '智能导题',
        '/admin/paper-list': '试卷管理',
        '/admin/paper-import': '试卷解析',
        '/admin/paper-upload': '原始上传',
        '/admin/albums': '专辑管理',
        '/admin/oss-manager': 'OSS资源管理',
        '/admin/ad-manager': '广告管理',
        '/admin/announcements': '公告管理',
        '/admin/feedbacks': '反馈管理',
        '/admin/forum-manager': '论坛管理',
        '/admin/ip-blacklist': 'IP黑名单管理',
        '/admin/sensitive-words': '敏感词管理',
        '/admin/moderation-logs': '审核日志',
        '/admin/pricing': '价格与促销管理',
        '/admin/download-logs': '下载列表'
    }
    return map[route.path] || '概览'
})

const handleMenuSelect = (index) => {
    router.push(index)
}

const handleLogout = () => {
    store.dispatch('logout')
    router.push('/home')
}
</script>

<style scoped>
.admin-wrapper {
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background-color: #f5f7f9;
}

.admin-full-height {
    height: 100%;
}

/* Sidebar Styles */
.admin-sidebar {
    background-color: #001529;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
    z-index: 1001;
    overflow-x: hidden;
}

.sidebar-logo {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    background: #002140;
    color: white;
    gap: 12px;
}

.logo-img {
    width: 32px;
    height: 32px;
    border-radius: 4px;
}

.logo-text {
    font-size: 18px;
    font-weight: 700;
    white-space: nowrap;
}

.admin-menu {
    border-right: none;
    padding-top: 10px;
}

.admin-menu :deep(.el-menu-item) {
    margin: 4px 0;
}

.admin-menu :deep(.el-menu-item.is-active) {
    background-color: var(--el-color-primary) !important;
    color: #fff !important;
}

/* Header Styles */
.admin-header {
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-bottom: 1px solid #e6e6e6;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    z-index: 1000;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 20px;
}

.collapse-btn {
    font-size: 20px;
    cursor: pointer;
    color: #606266;
    transition: color 0.3s;
}

.collapse-btn:hover {
    color: var(--el-color-primary);
}

.header-right {
    display: flex;
    align-items: center;
}

.admin-user {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background 0.3s;
}

.admin-user:hover {
    background: #f5f7fa;
}

.admin-username {
    font-size: 14px;
    color: #606266;
}

/* Main Content Styles */
.admin-main {
    background-color: #f5f7f9;
    padding: 20px;
    height: calc(100vh - 60px);
    overflow-y: auto;
}

/* Transitions */
.transition-all {
    transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.fade-transform-enter-active,
.fade-transform-leave-active {
    transition: all 0.3s;
}

.fade-transform-enter-from {
    opacity: 0;
    transform: translateX(-10px);
}

.fade-transform-leave-to {
    opacity: 0;
    transform: translateX(10px);
}

:deep(.el-sub-menu__title) {
    color: rgba(255, 255, 255, 0.7) !important;
}

:deep(.el-sub-menu__title:hover) {
    background-color: rgba(255, 255, 255, 0.05) !important;
}
</style>
